import { useState } from "react";
import { faqs } from "@/mocks/siteData";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="关于下载、地址和阅读的常见疑问"
          desc="这里整理了几个新读者最常提到的问题，点击标题即可展开查看解答。如果仍有疑问，可以在客户端的“帮助与反馈”里继续提交。"
        />

        <div className="reveal mx-auto mt-12 max-w-4xl">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="mb-3 overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                >
                  <span className="flex items-center gap-3">
                    <span className="font-heading text-sm text-primary-600">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-sm font-medium text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-xl text-foreground-400 transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    } ri-arrow-down-s-line`}
                    aria-hidden="true"
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[4.25rem]">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}